import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

import { CustomerItemDto } from '@/api/generated';
import { DialogFullWidthStyle } from '@/styles/dialog.styles.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { CustomersTable } from '@/views/customers/list/components/table/CustomersTable.comp.tsx';
import { ProcessCreateAddCustomerTableRow } from '@/views/processesCreate/components/ProcessCreateAddCustomerTableRow.comp.tsx';
import { ProcessCustomerPickerTableRow } from '@/views/processesCreate/components/ProcessCustomerPickerTableRow.comp.tsx';
import { ProcessAddCustomerDialogButton } from '@/views/processesDetails/components/dialog/addCustomer/components/ProcessAddCustomerDialogButton.comp.tsx';

interface Props {
  onCloseClick: () => void;
  /**
   * The customer of a process is chosen (creation or change of the customer), so only an ACTIVE customer
   * can be selected; a contact accepts a customer in any status, e.g. a Prospekt.
   */
  onlyProcessCustomers?: boolean;
  onSelectCustomer: (customer: CustomerItemDto) => void;
  tableKey?: string;
  urlStateEnabled?: boolean;
}

const tableKeyDefault = 'addCustomer';

export const ProcessAddCustomerDialog: React.FC<Props> = props => {
  const {
    onCloseClick: handleCloseClick,
    onlyProcessCustomers = false,
    onSelectCustomer: handleSelectCustomer,
    tableKey,
    urlStateEnabled = true,
  } = props;
  const { t } = useTranslationWithPrefix('views.processesUpdate.dialog.addCustomer');
  const parsedTableKey = tableKey ?? tableKeyDefault;

  return (
    <Dialog open={true} sx={DialogFullWidthStyle}>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <CustomersTable
          actionsColumns
          additionalButtons={[{ button: ProcessAddCustomerDialogButton, name: parsedTableKey }]}
          customRow={
            onlyProcessCustomers ? ProcessCustomerPickerTableRow : ProcessCreateAddCustomerTableRow
          }
          onCustomAction={handleSelectCustomer}
          pageSize={5}
          tableKey={parsedTableKey}
          urlStateEnabled={urlStateEnabled}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick} variant="outlined">
          {t('button.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
